export default __webpack_public_path__ + "static/media/ursinebond.81715182.png";